<template>
	<div class="detail">
		<div class="title fColor1 topshadow">
			<div class="inblock">
				<span>{{$t('lever.nowentrust')}}</span>
			</div>
			<div class="inblock fr">
				<!-- <span class="all" @click="links">{{$t('lever.lvchi')}}</span>
				<span class="all" @click="recordList">{{$t('lever.tdrecord')}}</span> -->
				<span class="all" @click="all">{{$t('lever.tdrecord')}}</span>
			</div>
		</div>
		<div class="content">
			<ul class="list-title fColor2 ft12 bdb clear">
				<li class="fl w12">{{$t('lever.type')}}</li>
				<li class="fl w12">{{$t('lever.jiaoyinum')}}</li>
				<li class="fl w12">{{$t('lever.purchase')}}</li>
				<li class="fl w12">{{$t('lever.nowPrice')}}</li>
				<li class="fl w12">{{$t('lever.Expected')}}</li>
				<li class="fl w12">{{$t('lever.countdown')}}</li>
				<!-- <li class="fl w12">{{$t('td.time')}}</li>
				<li class="fl w12">{{$t('lever.type')}}</li>
				<li class="fl w12">{{$t('cuy.price')}}</li>
				<li class="fl w8">{{$t('lever.tdnum')}}</li>
				<li class="fl w8">倒计时</li> -->
			</ul>
			<div class="containers scroll" v-if="deList.length>0">
				<ul v-for="(itm,index) in deList" :key="index" class="list-item fColor1 ft12">
					<li class="clear">
						<!-- <span class="fl w12">{{itm.updated_at}}</span>
						<span class="f1 w12">{{itm.type == 1? $t('td.buyin'):$t('td.sellout')}} </span>
						<span class="fl w12">{{itm.open_price | tofixedFour}}</span>
						<span class="fl w8">{{itm.number | tofixed}}</span>
						<span class="fl w8">{{countDown(itm.endTime,index,itm.seconds,itm.remain_milli_seconds,itm.id)}}s</span> -->
						<span class="fl w12" v-if="itm.type == 1">{{$t('lever.domore')}}</span>
						<span class="fl w12" v-else-if="itm.type == 2">{{$t('lever.doshort')}}</span>
						<span class="fl w12">{{ itm.number| to }}</span>
						<span class="fl w12">{{ itm.open_price| tofixedFour }}</span>
						<span class="fl w12" v-if="itm.status == 1">{{numnewprice}}</span>
						<span v-if="itm.status == 1 && (itm.open_price -0) == (numnewprice - 0)"
							class="fl w12 green">0</span>
						<span v-if="itm.status == 1 && itm.type == 1 && (itm.open_price -0) < (numnewprice -0)"
							class="fl w12 green">
							{{itm.number * (itm.profit_ratio / 100)|| '0' | tofixedFour}}</span>
						<span v-if="itm.status == 1 && itm.type == 1 && (itm.open_price -0) > (numnewprice -0)"
							class="fl w12 red">
							-{{(itm.number * (itm.loss_ratio / 100) -0) || '0.00' | tofixedFour}}
						</span>
						<span v-if="itm.status == 1 && itm.type == 2 && (itm.open_price -0) < (numnewprice -0)"
							class="fl w12 red">
							-{{(itm.number * (itm.loss_ratio / 100) -0) || '0.00' | tofixedFour}}
						</span>
						<span v-if="itm.status == 1 && itm.type == 2 && (itm.open_price -0) > (numnewprice -0)"
							class="fl w12 green">
							-{{(itm.number * (itm.profit_ratio / 100) -0) || '0.00' | tofixedFour}}</span>
						<!-- <view v-if="item.status == 1 && (item.open_price - 0) == (newprice -0)" class="flex1 tc green">0
						</view>
						<view v-if="item.status == 1 && item.type == 1 && (item.open_price - 0) < (newprice - 0)"
							class="flex1 tc green">
							{{item.number * newprice * (numrofit_ratio / 100) || '0' | toFixedNum}}
						</view>
						<view v-if="item.status == 1 && item.type == 1 && (item.open_price -0) > (newprice -0)"
							class="flex1 tc red">
							-{{(item.number * newprice -0) || '0.00' | toFixedNum}}
						</view>
						<view v-if="item.status == 1 && item.type == 2 && (item.open_price -0) < (newprice -0)"
							class="flex1 tc red">
							-{{(item.number * newprice -0) || '0.00' | toFixedNum}}
						</view>
						<view v-if="item.status == 1 && item.type == 2 && (item.open_price -0) > (newprice -0)"
							class="flex1 tc green">
							{{(item.number * newprice * (numrofit_ratio / 100) -0) || '0.00' | toFixedNum}}
						</view> -->
						<span class="fl w12 white" v-if="itm.endTime">
							<!-- {{countDown(itm.endTime,index,itm.seconds,itm.remain_milli_seconds,itm.id)}}s -->
							{{countDown(itm.endTime,index,itm.seconds,itm.remain_milli_seconds,itm.id)}}s
							<span style="visibility: hidden;display: none;">{{int}}</span><strong></strong>
						</span>
					</li>
				</ul>
			</div>
			<div class="no_data tc" v-if="deList.length<=0">
				<img src="../../assets/images/nodata.png" alt="">
				<p class="fColor2 ft18">{{$t('td.nodata')}}</p>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		name: "detail",
		data() {
			return {
				numnewprice: 0,
				page: 1,
				limit: 10,
				address: '',
				isChoosed: 2,
				new: false,
				wayList: [this.$t('td.buyin'), this.$t('td.sellout'), this.$t('td.all')],
				deList: [],
				legal_id: '',
				currency_id: '',
				CountDown: '',
				int: ''
			}
		},
		filters: {
			to: function(value) {
				value = Number(value);
				return value;
			},
			tofixed: function(val) {
				val = Number(val);
				return val.toFixed(2);
			},
			tofixedFour: function(val) {
				val = Number(val);
				return val.toFixed(4);
			},
		},
		created() {
			this.address = localStorage.getItem('address') || '';
			this.legal_id = localStorage.getItem('legal_id');
			this.currency_id = localStorage.getItem('currency_id');
			var that = this;
			that.upPrice(this.legal_id, this.currency_id);
			that.complete(this.legal_id, this.currency_id);
			eventBus.$on('to_leverExchange', function(data) {
				if (data) {
					that.complete(localStorage.getItem('legal_id'), localStorage.getItem('currency_id'));
				}
			})
		},
		methods: {
			upPrice(legal_id, currency_id) {
				var that = this;
				that.$socket.emit("login", localStorage.getItem("user_id"));
				that.$socket.on("kline", msg => {
					that.int = msg.currency_name;
					if (msg.type == "kline") {
						if (msg.currency_id == currency_id && msg.legal_id == legal_id && msg.api_form ==
							"huobi_websocket") {
							that.numnewprice = msg.close;
							window.localStorage.setItem('lastPrice', that.numnewprice);
						}
					}
				});
			},
			Djs_time() {
				let _this = this;
				this.sets = setInterval(() => {
					var presentTime = new Date().getTime();
					this.CountDown = presentTime
				}, 200);
			},
			iTofixed(values, numbers) {
				let val = Number(values);
				let num = Number(numbers);
				let nums = Number(numbers - 0 + 1);
				let base = '10';
				let decimal = base.padEnd(nums, 0) - 0;
				var vals = (Math.floor(val * decimal) / decimal).toFixed(num);
				return vals;
			},
			// // 订单倒计时
			countDown(val, indexs, seconds, relSeconds, ids) {
				var that = this;
				that.secods = relSeconds;
				var timeValue = '';
				var process = 100 / Number(seconds);
				var endItem = val; //获取列表传的截止时间
				var nowItem = new Date().getTime(); //获取当前时间
				var timeSpace = Number(endItem) - Number(nowItem); //截止时间减去当前时间
				if (timeSpace > 0) {
					seconds = that.iTofixed(timeSpace / 1000, 0);
					return seconds;
				} else if (timeSpace <= 0) {
					that.deList.forEach(function(item, index) {
						if (ids == item.id) {
							that.deList.splice(index, 1)
						}
					})
					return 0.0;
				}
			},
			wayChoosed(index) {
				this.isChoosed = index;
			},
			//我的交易记录
			complete(legals_id, currencys_id) {
				var that = this;
				var arr = [];
				this.$http({
						url: "/api/" + "microtrade/lists",
						method: "post",
						data: {
							page: that.page,
							limit: that.limit,
							status: that.buyType == '2' ? 2 : 1,
							match_id: window.localStorage.getItem('ainid')
						},
						headers: {
							Authorization: localStorage.getItem("token")
						}
					})
					.then(res => {
						arr = res.data.message.data;
						if (arr.length > 0) {
							var nowTime = new Date().getTime();
							for (var i = 0; i < arr.length; i++) {
								arr[i].endTime = (nowTime - 0) + (arr[i].remain_milli_seconds - 0);
							}
							that.deList = arr;
							that.Djs_time();
							that.set = setTimeout(that.countDown, 200);
						}
					})
					.catch(error => {});
			},
			// connect(){
			//     var that = this;
			//      that.$socket.emit("login", localStorage.getItem('user_id'));
			//     that.$socket.on('deal_list',function(msg){
			//         if(msg.type == 'deal_list'){
			//             var complete = JSON.parse(msg.complete);
			//             console.log(complete);
			//             that.deList = complete;
			//         }
			//         console.log(msg);
			//     })
			// },
			all() {
				this.$router.push({
					name: 'allTransac'
				})
			},
			// 杠杆持仓
			links() {
				this.$router.push({
					name: 'leverTransactions'
				})
			},
			// 跳转交易记录
			recordList() {
				this.$router.push({
					name: 'leverList'
				})
			}

		},
		mounted() {
			var that = this;
			// this.currency_id=localStorage.getItem('currency_id');
			//   eventBus.$on('toTrade0', function (data0) {
			//         that.currency_id=data0.currency_id
			//         that.legal_id=data0.legal_id
			//         that.complete(data0.legal_id,data0.currency_id)
			//   });
			//    eventBus.$on('toTrade', function (data0) {
			//         that.currency_id=data0.currency_id
			//         that.legal_id=data0.legal_id
			//         that.complete(data0.legal_id,data0.currency_id)
			//   })
			eventBus.$on('buyTrade', function(data) {
				// that.connect();
			});
		}
	}
</script>
<style scoped>
	.red {
		color: #cc4951;
		cursor: pointer;
	}

	.title {
		height: 48px;
		line-height: 46px;
		padding: 0 40px 0 30px;
	}

	.tab_title {
		display: inline-block;
		line-height: 46px;
		height: 46px;
	}

	.tab_title span {
		cursor: pointer;
	}

	.tab_title span:not(:last-child) {
		margin-right: 40px;
	}

	.content {
		padding: 0 40px 0 30px;
		height: 330px;
	}

	.list-title {
		line-height: 40px;
		height: 40px;
		display: flex;
	}

	.list-title li {
		/* width: 16.666%; */
		flex: 1;
		text-align: center;
	}

	.no_data {
		padding: 50px 0;
	}

	.containers {
		height: 260px;
		overflow: auto;
	}

	.list-item li {
		line-height: 45px;
		display: flex;
	}

	.list-item li span {
		display: block;
		float: left;
		width: 20%;
		text-align: center;
	}

	.list-item li:hover {
		background-color: rgba(46, 55, 83, .4)
	}

	.list-item li span.green {
		color: #12b886
	}

	.all {
		cursor: pointer;
		color: #7a98f7;
		margin-left: 10px;
	}
</style>



// WEBPACK FOOTER //
// src/view/contract/lever_tion.vue